<template>
  <div>
    <tk-flex between>
      <public-header title="救援详情" show-back/>
      <a-button
        v-if="pageData && pageData.objectId && pageData.status === 'finish' && pageData.feedbackRecord && pageData.feedbackRecord.length && can('replyRoadRescueModel')"
        type="primary"
        @click="areaModal = true" >
        回复
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading">
      <div class="full-width bg-white border-radius-12 p-24" style="color: #363B45">
        <!-- 订单号 -->
        <tk-flex middle wrap :gutter="8"  >
          <div class="p-r-8 font-bold font-20">订单号：{{ pageData.number }}</div>
          <div class="p-x-8 p-y-4" :style="{'border-radius': '6px','border': '1px solid' + statusStyle(pageData).color,'color': statusStyle(pageData).color}" >{{ statusStyle(pageData).name }}</div>
        </tk-flex>
        <!-- 基本信息 -->
        <div>
          <div class="font-14 font-bold m-t-24 m-b-10" >基本信息</div>
          <a-row :gutter="[12,0]" class="font-12" style="color: #363B45;line-height:32px">
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              <div style="line-height:32px">
                用户：{{ pageData.user.nickName }}
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              手机号：{{ pageData.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              报修时间：{{ pageData.time | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              故障原因：{{ pageData.malfunction }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.status === 'finish' || pageData.status === 'receive'"  >
              接单时间：{{ pageData.receiveTime | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.status === 'cancel'"  >
              取消时间：{{ pageData.cancelTime | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.status === 'cancel'"  >
              取消原因：{{ pageData.cancelReason }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.status === 'finish'"  >
              完成时间：{{ pageData.finishTime | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" >
              详细地址：{{ pageData.address }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.voice" >
              <tk-flex>
                <div style="flex-shrink:0">语音描述：</div>
                <a-button type="primary" icon="play-circle" @click="audioVisable = true"></a-button>
              </tk-flex>
            </a-col>
          </a-row>
          <a-row class="m-t-10" style="color: #363B45">
            <a-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24" v-if="pageData.images && pageData.images.length">
              <tk-flex>
                <div style="flex-shrink:0">图片：</div>
                <ak-type-input hideLabel v-model="pageData.images" :field="imagesField"/>
              </tk-flex>
            </a-col>
          </a-row>
        </div>
        <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>

        <!-- 接单门店 -->
        <div v-if="pageData.store" class="m-t-20">
          <div class="font-14 font-bold m-t-14 m-b-10" >接单门店</div>
          <a-row :gutter="[12,0]" class="font-12" style="color: #363B45;line-height:32px">
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              门店名称：{{ pageData.store.fullName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              所属代理：{{ pageData.store.agent.fullName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              所属地区：{{ $tkRegions.getFullName(pageData.store.region) }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              联系电话：{{ pageData.store.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              门店地址：{{ pageData.store.address }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>

        <!-- 订单反馈 -->
        <div v-if="pageData && pageData.feedbackRecord && pageData.feedbackRecord.length" class="m-t-20">
          <div class="font-14 font-bold m-t-24 m-b-20" >订单反馈</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(t,i) in pageData.feedbackRecord" :key="i" style="word-break: break-all;"  >
              {{ t.type === 'user' ? '用户' : '平台' }}反馈内容：{{ t.content }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
      </div>
    </a-spin>
    <!-- 回复弹窗 -->
    <!-- 播放音频 -->
    <a-modal
      v-model="audioVisable"
      :footer="null"
    >
      <ak-type-input hideLabel v-model="pageData.voice" :field="voiceField"/>
    </a-modal>

    <!-- 弹框 -->
    <a-modal
      :title="'回复'"
      :confirmLoading="confirmLoading"
      :visible="areaModal"
      @ok="save"
      @cancel="
        () => {
          areaModal = !areaModal;
          area = {};
        }
      "
    >
      <ak-type-input ref="feedback" v-model="feedback" :field="feedbackField" hideLabel style="width: 100%;padding: 24px !important;" />
    </a-modal>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
export default {
  components: {
    publicHeader
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      voiceField: {
        name: 'voice',
        note: '语音描述',
        type: 'Video',
        disabled: true
      },
      imagesField: {
        name: 'images',
        note: '图片',
        type: 'Array',
        items: {
          type: 'Image'
        },
        disabled: true
      },
      audioVisable: false,
      confirmLoading: false,
      areaModal: false, // 弹框
      feedback: '', // 战区
      feedbackField: {
        name: 'feedback',
        type: 'String',
        style: 'textarea',
        placeholder: '请输入回复',
        validators: [
          (val) => val ? null : '不可为空'
        ]
      }
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      try {
        let { data } = await this.$tkParse.get(`/classes/roadRescue/${this.$route.query.id}`, {
          params: {
            include: 'user,store,store.agent'
          }
        })
        this.pageData = data
        this.loading = false
      } catch (e) {}
    },
    statusStyle (pageData) {
      if (!pageData) return {}
      let obj = {
        wait: {
          status: 'wait',
          name: '待接单',
          color: '#FF9F0E'
        },
        receive: {
          status: 'receive',
          name: '已接单',
          color: '#2F82FF'
        },
        finish: {
          status: 'finish',
          name: '已完成',
          color: '#808690'
        },
        cancel: {
          status: 'cancel',
          name: '已取消',
          color: '#808690'
        }
      }
      return obj[pageData.status]
    },
    // 保存
    async save () {
      try {
        if (this.feedback === '') {
          this.$notification['warning']({
            message: '警告',
            description: '内容不可为空'
          })
          return
        }
        this.confirmLoading = true
        await this.$tkParse.post(`/roadRescue/feedback`, {
          id: this.pageData.objectId,
          user: this.$store.state.user.objectId,
          type: 'admin',
          content: this.feedback,
          feedback: '2'
        })
        this.$notification['success']({
          message: '设置成功',
          description: '保存成功'
        })
        this.feedback = ''
        this.areaModal = false
        this.confirmLoading = false
        this.getInit()
      } catch (error) {
        console.log(error)
        this.confirmLoading = false
        this.$notification['error']({
          message: '设置失败',
          description: '网络错误,请重试'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .array-img-input-wrap{
    .ignore-item {
      display: none;
    }
  }
  .ant-modal-body{
    padding: 0 !important;
  }
}
</style>
